import { Dispatch, SetStateAction, FC, memo, useState, useEffect } from 'react'
import { Divider, HStack, Stack, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react'

import { ActivityType } from 'Activities/types'
import { FilterGroupHeader, FormItem } from 'components'
import ActivitiesTypesSelectInList from './components/ActivitiesTypesSelectInList'

export type FilterGroupByActivitiesTypesProps = {
  title: string
  description: string
  values: any
  setValues: Dispatch<SetStateAction<any>>
  readActivitiesTypes: () => Promise<any>
}

const FilterGroupByActivitiesTypes: FC<FilterGroupByActivitiesTypesProps> = ({
  title,
  description,
  setValues,
  values,
  readActivitiesTypes,
}) => {
  const [loadingActivitiesTypes, setLoadingActivitiesTypes] = useState(true)
  const [activitiesTypes, setActivitiesTypes] = useState<ActivityType[]>([])

  async function removeActivityType({ key, id }: { key: string; id: string }) {
    const activitiesTypesIds = values[key]
    const newActivitiesTypesIds = activitiesTypesIds.filter((currentId: string) => currentId !== id)
    setValues({ ...values, [key]: newActivitiesTypesIds })
  }

  async function loadActivitiesTypes() {
    setLoadingActivitiesTypes(true)
    const response = await readActivitiesTypes()
    if (response?.header?.success) {
      const activitiesTypesFromAPI = response.body.activity_type.elements
      setActivitiesTypes(activitiesTypesFromAPI)
    }
    setLoadingActivitiesTypes(false)
  }

  useEffect(() => {
    loadActivitiesTypes()
  }, [])

  function upldateAcitivitesTypesOnSelect() {
    const availableActivitiesTypes = activitiesTypes.filter(({ id }) => {
      return !values.has_activities_types.includes(id) && !values.has_not_activities_types.includes(id)
    })
    setActivitiesTypes(availableActivitiesTypes)
  }

  useEffect(() => {
    upldateAcitivitesTypesOnSelect()
  }, [values.has_activities_types, values.has_not_activities_types])

  return (
    <FilterGroupHeader
      title={title}
      description={description}
      content={
        <Stack spacing={2}>
          <FormItem label="Se POSSUEM estes tipos de atividades">
            {values.has_activities_types.length > 0 && (
              <HStack mb={4}>
                {values.has_activities_types.map((id: string) => {
                  return (
                    <Tag bg="bgContainer" key={id} variant="filter-tags">
                      <TagLabel>{id}</TagLabel>
                      <TagCloseButton onClick={() => removeActivityType({ key: 'has_activities_types', id })} />
                    </Tag>
                  )
                })}
              </HStack>
            )}

            <ActivitiesTypesSelectInList
              name="has_activities_types"
              filter={values}
              setFilter={setValues}
              activitiesTypes={activitiesTypes}
              loadingActivitiesTypes={loadingActivitiesTypes}
            />
          </FormItem>

          <Divider />

          <FormItem label="Se NÃO POSSUEM estes tipos de atividades">
            {values.has_not_activities_types.length > 0 && (
              <HStack mb={4}>
                {values.has_not_activities_types.map((id: string) => {
                  return (
                    <Tag bg="bgContainer" key={id} variant="filter-tags">
                      <TagLabel>{id}</TagLabel>
                      <TagCloseButton onClick={() => removeActivityType({ key: 'has_not_activities_types', id })} />
                    </Tag>
                  )
                })}
              </HStack>
            )}

            <ActivitiesTypesSelectInList
              name="has_not_activities_types"
              filter={values}
              setFilter={setValues}
              activitiesTypes={activitiesTypes}
              loadingActivitiesTypes={loadingActivitiesTypes}
            />
          </FormItem>
        </Stack>
      }
    />
  )
}

export default memo(FilterGroupByActivitiesTypes)
